import { useEffect } from 'react';
import { useLocation } from 'wouter';

export function PageTracker() {
  const [location] = useLocation();

  useEffect(() => {
    // Track page view with Google Analytics
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location,
      });
    }
  }, [location]);

  return null;
}
